/**
 * Downloads a remote file keeping its original filename.
 *
 * Fetches the file into a blob so the `download` attribute is honoured even
 * on cross-origin URLs (signed GCS links carry no Content-Disposition).
 *
 * @param {string} url
 * @param {string} [filename]
 * @returns {Promise<boolean>} whether the file was downloaded (false = opened in a new tab)
 */
export async function downloadFile(url, filename) {
  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Download failed: ${response.status}`);
    }

    const objectUrl = URL.createObjectURL(await response.blob());
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename || 'download';
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    return true;
  } catch {
    // ponytail: URL assinada sem CORS -> abre em nova aba; ajustar CORS do bucket se incomodar
    window.open(url, '_blank', 'noopener');
    return false;
  }
}
